import { applyWhiteLabelThemeToDocument, createWhiteLabelTheme } from "../shared/theme";

export const whiteLabelTheme = createWhiteLabelTheme({
  font: {
    sans: '"Inter", system-ui, sans-serif',
  },
  componentClasses: {
    button: {
      base: "",
      solid: "",
      solidBgColor: "",
      solidTextColor: "",
      outline: "",
      outlineBorderColor: "",
      outlineTextColor: "",
    },
    card: {
      base: "",
      bgColor: "",
      borderColor: "",
      textColor: "",
      mutedBgColor: "",
      softBgColor: "",
      titleColor: "",
      subtitleColor: "",
    },
    dashboardCard: {
      base: "",
      bgColor: "",
      borderColor: "",
      textColor: "",
      mutedTextColor: "",
      accentBgColor: "",
      accentTextColor: "",
    },
    input: {
      base: "",
      bgColor: "",
      borderColor: "",
      textColor: "",
      placeholderColor: "",
      labelColor: "",
      focusBorderColor: "",
      focusRingColor: "",
      errorBorderColor: "",
      errorTextColor: "",
    },
    select: {
      trigger: "",
      bgColor: "",
      borderColor: "",
      textColor: "",
      placeholderColor: "",
      menu: "",
      option: "",
      optionHoverBgColor: "",
    },
    nav: {
      linkColor: "",
      linkHoverColor: "",
      menuBgColor: "",
      menuBorderColor: "",
      menuItemColor: "",
      menuItemHoverBgColor: "",
    },
    footer: {
      root: "",
      bgColor: "",
      textColor: "",
      brandTextColor: "",
      socialBgColor: "",
      socialTextColor: "",
      borderColor: "",
    },
    modal: {
      overlayBgColor: "",
      panelBgColor: "",
      panelTextColor: "",
      panelBorderColor: "",
      titleColor: "",
      closeButtonColor: "",
      bodyTextColor: "",
    },
    table: {
      headerBgColor: "",
      headerTextColor: "",
      rowBgColor: "",
      rowTextColor: "",
      borderColor: "",
      controlBgColor: "",
      controlTextColor: "",
      controlBorderColor: "",
      accentBgColor: "",
      accentTextColor: "",
    },
    header: {
      root: "",
      bgColor: "",
      textColor: "",
      brandTextColor: "",
      phoneTextColor: "",
      menuIconColor: "",
      loginButton: "",
      loginButtonBgColor: "",
      loginButtonTextColor: "",
    },
    sidebar: {
      root: "",
      bgColor: "",
      textColor: "",
      brandTextColor: "",
      activeItem: "",
      activeItemBgColor: "",
      activeItemTextColor: "",
      inactiveItem: "",
      inactiveItemTextColor: "",
      toggleButton: "",
      toggleButtonBgColor: "",
      toggleIconColor: "",
    },
    progressIndicator: {
      wrapperClassName: "bg-gradientbar",
      labelClassName: "",
    },
  },
  colors: {
    canvas: "#FFF9F2",
    canvasMuted: "#F7F5F2",
    surface: "#FFFFFF",
    surfaceSubtle: "#F8FAFC",
    surfaceMuted: "#FFF1D3",
    surfaceSoft: "#EAE4DA",
    primary: "#0E7C66",
    primaryAlt: "#0D9488",
    primaryHover: "#0A5C4D",
    primarySoft: "#D7F1EA",
    accent: "#FFD400",
    accentHover: "#FFC400",
    accentStrong: "#FF8A00",
    accentSoft: "#FFF4B8",
    text: "#1C1C1C",
    textMuted: "#5F5F5F",
    textSoft: "#7A7A7A",
    textPlaceholder: "#9CA3AF",
    textInverse: "#FFFFFF",
    border: "#D8D8D8",
    borderStrong: "#B8B8B8",
    borderLight: "#F3F4F6",
    overlay: "rgba(0, 0, 0, 0.5)",
    success: "#15803D",
    successSoft: "#ECFDF3",
    successSoftAlt: "#ECFDF5",
    successPale: "#F0FDF4",
    successBright: "#22C55E",
    successHero: "#34D399",
    successStrong: "#16A34A",
    successDeep: "#047857",
    successBorderSoft: "#A7F3D0",
    successBrightSoft: "#DCFCE7",
    successTextStrong: "#15803D",
    warning: "#EA580C",
    warningSoft: "#FFF7ED",
    warningBright: "#EAB308",
    warningPale: "#FEFCE8",
    warningBrightSoft: "#FEF9C3",
    warningTextStrong: "#CA8A04",
    warningAlt: "#FB923C",
    warningHero: "#FACC15",
    danger: "#DC2626",
    dangerSoft: "#FEF2F2",
    dangerBright: "#EF4444",
    dangerHero: "#F87171",
    dangerBrightSoft: "#FEE2E2",
    dangerTextStrong: "#B91C1C",
    info: "#2563EB",
    infoSoft: "#EFF6FF",
    infoBright: "#3B82F6",
    infoSoftAlt: "#DBEAFE",
    infoTextStrong: "#2563EB",
    infoAccent: "#2684FF",
    purpleSoft: "#F3E8FF",
    purplePale: "#FAF5FF",
    purpleStrong: "#9333EA",
    purpleText: "#A855F7",
    orangeSoft: "#FFEDD5",
    orangeText: "#EA580C",
    shadow: "rgba(15, 23, 42, 0.08)",
  },
  gradients: {
    primary: {
      start: "#FFD200",
      end: "#FF8A00",
    },
    accent: {
      start: "#22D3EE",
      end: "#F87171",
    },
    step: {
      start: "#FFD200",
      end: "#FF8A00",
    },
  },
});

export function applyWhiteLabelTheme() {
  applyWhiteLabelThemeToDocument(whiteLabelTheme);
}
